// Modules.
import React, { Component } from 'react';

// Styles.
import './App.scss';

// Assets.
import logo from './images/logo.png';

class App extends Component {
	render() {
		return (
			<div className="App">
				<div className="info">
					<img className="logo" src={ logo } alt="Parian Logistics" />
					<div className="contentWrapper">
						<p className="companyTagline">
							Parian Logistics has been established to provide 3PL logistics, e-commerce and real estate management services out of the Gamble Place facility.
						</p>
						<h4 className="contactUs">Contact Us</h4>
						<div className="contactDetail">
							<div className="type"><h4>E</h4></div>
							<p><a href="mailto:inquiries@parianlogistics.com">inquiries@parianlogistics.com</a></p>
						</div>
						<div className="contactDetail">
							<div className="type"><h4>T</h4></div>
                            <div>
                                <p>204.975.4624</p>
                                <p>844.727.4265 (844.PARIANL)</p>
                            </div>
						</div>
					</div>
				</div>
				<div className="sidePanel" />
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js